module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-9d49945787b02cfcf6e7efa97a95ca9f.png";